module.exports = __webpack_public_path__ + "img/ascend_gold14.590e243e.png";